import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => localStorage.getItem("hma_admin_token") || "";
export const setAdminToken = (t) => localStorage.setItem("hma_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("hma_admin_token");

export const adminHeaders = () => ({ "X-Admin-Password": getAdminToken() });

// Resolve a stored image/datasheet URL (may be a relative /api/... path) to absolute
export const resolveUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const CATEGORIES = [
  "Concrete Admixtures",
  "Cement Grinding Aid",
  "Mortar",
  "3D Concrete Fence",
];

// Categories that are physical products (dimensions/color) rather than liquid chemicals.
export const PHYSICAL_CATEGORIES = ["3D Concrete Fence"];
export const isPhysical = (cat) => PHYSICAL_CATEGORIES.includes(cat);

// Spec rows shown in the product modal and PDF, adapted to the product type.
export const getSpecRows = (p) => {
  if (isPhysical(p.category)) {
    return [
      ["Product Code", p.code],
      ["Category", p.category],
      ["Dimensions", p.dimensions],
      ["Depth", p.width],
      ["Color", p.color],
    ];
  }
  return [
    ["Product Code", p.code],
    ["Admixture Class / Standard", p.standard],
    ["Appearance / Colour", p.appearance],
    ["Specific Gravity @ 25°C", p.specific_gravity],
    ["pH Value", p.ph_value],
    ["Chloride Content", p.chloride_content],
    ["Recommended Dosage", p.dosage],
  ];
};
